import Modal from "@/components/Modal";
import React from "react";
import Image from "next/image";
import styles from "./index.module.scss";
import { useTranslation } from "next-i18next";
import BaseBtn from "./BaseBtn";
import { Prize } from "@/interfaces/pullNewType";
import IconFont from "@/components/IconFont";
import getFullWebCdnUrl from "@/utils/getFullWebCdnUrl";

interface PrizeModalProps {
  prize?: Prize;
  visible: boolean;
  isContinue: boolean;
  onClose: () => void;
  onBtnClick: () => void;
}

export default function PrizeModal({
  isContinue,
  visible,
  prize,
  onClose,
  onBtnClick,
}: PrizeModalProps) {
  const { t } = useTranslation("activities");

  if (!visible) {
    return null;
  }

  return (
    <Modal visible={visible} onClose={onClose} zIndex={9999}>
      <div className={styles.prizeModal}>
        <p className={styles.pTitle}>
          {t("got")} {prize?.price} USD !!
        </p>
        <div className={styles.imgW}>
          <Image
            src={getFullWebCdnUrl("/pulling-new/prize-bg.png")}
            alt="bg"
            width={226}
            height={158}
            style={{
              maxWidth: "100%",
              height: "auto"
            }}></Image>
          <div className={styles.img}>
            <Image
              src={prize?.icon as string}
              alt=""
              width={120}
              height={100}
              style={{
                maxWidth: "100%",
                height: "auto"
              }} />
          </div>
        </div>

        <div className={styles.pName}>
          {prize?.title} {t("stock")} x 1
        </div>
        <div className={styles.pDes}>{t("the-stock-will-be-transfered")}</div>

        <BaseBtn
          text={
            isContinue
              ? t("continue", { ns: "common" })
              : t("invite-friends-to")
          }
          className={styles.mBtn}
          onClick={onBtnClick}
        />
        <IconFont
          type="bg-close"
          className={styles.closeIcon}
          onClick={onClose}
        />
      </div>
    </Modal>
  );
}
